const NOTES = [146.83, 174.61, 196.0, 220.0, 261.63, 293.66];

export class PlanetAudio {
  private ctx: AudioContext | null = null;
  private master: GainNode | null = null;
  private muted = false;
  private timer = 0;
  private running = false;

  setMuted(muted: boolean): void {
    this.muted = muted;
    if (this.master && this.ctx) {
      this.master.gain.setTargetAtTime(muted ? 0 : 0.2, this.ctx.currentTime, 0.04);
    }
  }

  async start(): Promise<void> {
    if (!this.ctx) {
      const ctx = new AudioContext();
      const master = ctx.createGain();
      master.gain.value = this.muted ? 0 : 0.2;
      master.connect(ctx.destination);
      this.ctx = ctx;
      this.master = master;
      this.patchPad(ctx, master);
    }
    if (this.ctx.state === "suspended") {
      await this.ctx.resume();
    }
    if (!this.running) {
      this.running = true;
      this.scheduleNotes();
    }
  }

  dispose(): void {
    this.running = false;
    window.clearTimeout(this.timer);
    void this.ctx?.close();
    this.ctx = null;
    this.master = null;
  }

  private patchPad(ctx: AudioContext, master: GainNode): void {
    const merge = ctx.createGain();
    merge.gain.value = 0.22;
    const filter = ctx.createBiquadFilter();
    filter.type = "lowpass";
    filter.frequency.value = 420;
    filter.Q.value = 0.7;
    merge.connect(filter);
    filter.connect(master);

    const makeOsc = (freq: number, type: OscillatorType, detune: number): void => {
      const osc = ctx.createOscillator();
      osc.type = type;
      osc.frequency.value = freq;
      osc.detune.value = detune;
      const gain = ctx.createGain();
      gain.gain.value = 0.18;
      osc.connect(gain);
      gain.connect(merge);
      osc.start();
    };

    makeOsc(73.42, "sine", -6);
    makeOsc(73.42, "sine", 7);
    makeOsc(110, "triangle", -3);

    const lfo = ctx.createOscillator();
    lfo.type = "sine";
    lfo.frequency.value = 0.07;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 80;
    lfo.connect(lfoGain);
    lfoGain.connect(filter.frequency);
    lfo.start();
  }

  private scheduleNotes(): void {
    if (!this.running || !this.ctx || !this.master) {
      return;
    }
    const ctx = this.ctx;
    const now = ctx.currentTime;
    const freq = NOTES[Math.floor(Math.random() * NOTES.length)] ?? 196;
    const osc = ctx.createOscillator();
    osc.type = "triangle";
    osc.frequency.value = freq;
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.05, now + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 2.2);
    osc.connect(gain);
    gain.connect(this.master);
    osc.start(now);
    osc.stop(now + 2.3);
    const wait = 2400 + Math.random() * 2600;
    this.timer = window.setTimeout(() => this.scheduleNotes(), wait);
  }
}
